'use client';

import { useMount } from 'react-use';
import { fireVisitedTradeInEventsPage } from '~/services/analytics/events/tradeIn';

export function AnalyticsTradeInEventsPageVisited() {
  useMount(fireVisitedTradeInEventsPage);

  return null;
}
